<template>
  <div>
    <div class="application7">
      <div class="bannerTemp">
        <bannerTemp :data="bannerData"></bannerTemp>
      </div>
      <module1 :data="a"></module1>
      <module1 :data="b"></module1>
      <module1 :data="c" style="margin-bottom:150px;">
        <div slot="content">
          <img src="../../assets/images/application/application7-1.jpg" alt />
          <img src="../../assets/images/application/application7-2.jpg" alt />
          <img src="../../assets/images/application/application7-3.jpg" alt />
        </div>
      </module1>
    </div>
    <div class="mobile-application7">
      <div class="mobile-bannerTemp">
        <bannerTemp :data="bannerData" :isLong="true"></bannerTemp>
      </div>
      <div class="content">
        <div class="range">
          <div class="part-title">
            业务应用范围
          </div>
          <div class="part-content">
            <p>平安校园、智慧校园、虚拟校园、学校迎新、校园管线管理、校园资产管理等。</p>
          </div>
        </div>
        <div class="range">
          <div class="part-title">
            业务应用概述
          </div>
          <div class="part-content">
            <p>基于GIS、BIM、物联网技术，实现校园的学生管理的定位安全、招生、迎新、教务等功能，协同办公、项目管理、资产管理、设备管理、管线管理、教室房屋管理、校车管理等功能。</p>
          </div>
        </div>
        <div class="range">
          <div class="part-title">
            业务应用案例
          </div>
          <el-carousel class="carousel" indicator-position="outside" height="18rem" >
            <el-carousel-item v-for=" index in 3" :key="index">
              <img :src="getImg(`application7-${index}.jpg`)" alt="Carousel Image" style="width: 100%; object-fit: contain;">
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
  </div>
  
</template>

<script>
export default {
  name: "Application7",
  metaInfo: {
    title:
      "智慧校园可视化管理_行业三维可视化应用解决方案-上海臻图信息技术有限公司",
    meta: [
      {
        name: "keywords",
        content:
          "智慧校园,三维校园,智慧校园,平安校园虚拟校园,校园管线管理,校园资产管理"
      },
      {
        name: "description",
        content:
          "基于GIS、BIM、物联网技术,实现校园的学生管理的定位安全、招生、迎新、教务等功能,协同办公、项目管理、资产管理、设备管理、管线管理、教室房屋管理、校车管理等功能。"
      }
    ]
  },
  data() {
    return {
      bannerData: {
        title: "智慧校园可视化管理",
        p:
          "基于GIS、BIM、物联网技术，实现校园的学生管理的定位安全、招生、迎新、教务等功能，协同办公、项目管理、资产管理、设备管理、管线管理、教室房屋管理、校车管理等功能……"
      },
      a: {
        num: "01",
        name: "业务应用范围",
        p:
          "平安校园、智慧校园、虚拟校园、学校迎新、校园管线管理、校园资产管理等。"
      },
      b: {
        num: "02",
        name: "业务应用概述",
        p:
          "基于GIS、BIM、物联网技术，实现校园的学生管理的定位安全、招生、迎新、教务等功能，协同办公、项目管理、资产管理、设备管理、管线管理、教室房屋管理、校车管理等功能。"
      },
      c: {
        num: "03",
        name: "业务应用案例"
      }
    };
  },
  methods: {
    getImg(fileName) {
      return require(`@/assets/images/application/application7/${fileName}`);
    }
  },
  mounted: function() {}
};
</script>

<style lang="less" scoped>
//scoped
.bannerTemp {
  background-image: url("../../assets/images/other/header_bg.jpg");
}
.application7 {
  font-size: 0;
  img {
    &:nth-child(1) {
      width: 584px;
      margin-right: 20px;
    }
    &:nth-child(2) {
      width: 584px;
    }
    &:nth-child(3) {
      margin-top: 20px;
      width: 100%;
    }
  }
}
.mobile-application7 {
  display: none;
  width: 100%;
  flex-direction: column;
  font-family: 'Normal';
  .mobile-bannerTemp {
    width: 100%;
    background-image: url("../../assets/images/other/header_bg.jpg");
    background-position: 30%;
    background-size: cover;
    height: 28rem;
  }
  .content {
    width: 100%;
    font-family: 'Normal';
    .range {
      width: 100%;
      box-sizing: border-box;
      padding: 2rem;
      color: #333333;
      .part-title {
        width: 100%;
        text-align: center;
        font-size: 1.8rem;
        font-weight: bold;
        line-height: 3rem;
      }
      .part-content {
        font-size: 1rem;
        font-weight: 350;
        line-height: 2rem;
        margin-top: 2rem;
        text-indent: 2em;
      }
      .carousel {
        margin-top: 2rem;
      }
    }
  }
}
/deep/.el-carousel__indicators--horizontal  {
  width:100% !important;
  text-align: center !important;
  .is-active {
    .el-carousel__button {
      width: 3rem;
      height: 0.4rem;
      background: #3C80E8;
    }
  }
}
/deep/ .el-carousel__button {
  width: 0.5rem;
  height: 0.4rem;
  background: #C1E1FF;
}
/deep/ .case-carousel {
  .is-active {
    .el-carousel__button {
      width: 3rem;
      height: 0.4rem;
      background: #3C80E8;
    }
  }
}
@media (max-width: 1024px) {
  .application7 {
    display: none !important;
  }
  .bannerTemp {
    display: none !important;
  }
  .mobile-application7 { 
    display: flex !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/application/application7.vue